/*  Shared  */
import { debug } from 'application/Shared/Utils';

const Storage = (() => {
    const set = (item, value, callbackFn) => {
        try {
            localStorage.setItem(item, value);
            if (callbackFn) callbackFn(value);
        } catch (e) {
            debug.e('Failed to set localStorage', item);
            if (callbackFn) callbackFn(false);
        }
    };

    const get = async (item) =>
        new Promise((resolve) => {
            resolve(localStorage.getItem(item));
        });

    const getSync = (item) => localStorage.getItem(item);

    const remove = async (item) =>
        new Promise(() => {
            localStorage.removeItem(item);
        });

    // Stores a value with a specified time to live (TTL) in milliseconds.
    const setWithExpiry = async (key, value, ttlMilliseconds) => {
        const now = new Date();

        const item = {
            expiry: now.getTime() + ttlMilliseconds,
            value
        };

        try {
            localStorage.setItem(key, JSON.stringify(item));
        } catch (e) {
            debug.e(`Failed to set localStorage with expiry for ${key}`, e);
        }
    };

    // Reads a value and checks its expiry to either return the item or null.
    const getWithExpiry = async (key) => {
        const itemStr = localStorage.getItem(key);
        // if the item doesn't exist, return null
        if (!itemStr) {
            return null;
        }
        const item = JSON.parse(itemStr);
        const now = new Date();
        // compare the expiry time of the item with the current time
        if (now.getTime() > item.expiry) {
            // If the item is expired, delete the item from storage
            // and return null
            localStorage.removeItem(key);
            return null;
        }
        return item.value;
    };

    return {
        get,
        getSync,
        getWithExpiry,
        remove,
        set,
        setWithExpiry
    };
})();

export default Storage;
